export const ar = {
  common: {
    save: 'حفظ',
    cancel: 'إلغاء',
    edit: 'تعديل',
    delete: 'حذف',
    add: 'إضافة',
    remove: 'إزالة',
    download: 'تحميل',
    print: 'طباعة',
    preview: 'معاينة',
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجاح',
    home: 'الرئيسية',
    about: 'عني',
    ageCalculator: 'حاسبة العمر',
    dateDifference: 'حاسبة الفرق بين التواريخ',
    tafqit: 'تفقيط الأعداد',
    quickWhats: 'واتس سريع',
    qrGenerator: 'مولد QR',
    resume: 'السيرة الذاتية',
    greetingCards: 'بطاقات التهنئة',
    email: 'البريد الإلكتروني',
    serviceCodeTitle: 'أدخل رمز الخدمة',
    serviceCodeSubtitle: 'أدخل 3 أرقام للوصول السريع للخدمة',
    goToService: 'الانتقال للخدمة',
    serviceCodeExamples: 'أمثلة على رموز الخدمات:',
    invalidCode: '000',
    todayDate: 'تاريخ اليوم',
    hijriCalendar: 'التقويم الهجري',
    gregorianCalendar: 'التاريخ الميلادي',
    currentTime: 'الوقت الحالي',
    timezone: 'المنطقة الزمنية',
    copyDate: 'نسخ التاريخ',
    day: 'اليوم',
    month: 'الشهر',
    year: 'السنة',
    footerCopyright: 'صنع بكل ❤️ في 🇸🇦',
    widgetSectionTitle: 'خدمات و أدوات مجانية',
    widgetSectionSubtitle: 'ادوات متنوعة و سهلة الاستخدام برمجة بكل',
    cards: [
      {
        title: 'حاسبة العمر',
        description: 'احسب عمرك بالتقويم الميلادي والهجري مع معلومات إضافية'
      },
      {
        title: 'حاسبة الفرق بين التواريخ',
        description: 'احسب الفرق بين أي تاريخين بالتقويم الميلادي والهجري'
      },
      {
        title: 'تفقيط الأعداد',
        description: 'تحويل الأعداد إلى نصوص مكتوبة.'
      },
      {
        title: 'واتس مباشر',
        description: 'إرسال رسائل سريعة إلى أي جهاز يعمل بنظام التشغيل Android.'
      },
      {
        title: 'مولد رمز الاستجابة السريعة',
        description: 'إنشاء رمز الاستجابة السريعة بأسهل طريقة.'
      },
      {
        title: 'السيرة الذاتية الذكية',
        description: 'إنشاء السيرة الذاتية الذكية بأسهل طريقة.'
      },
      {
        title: 'بطاقات التهنئة',
        description: 'إنشاء بطاقات تهنئة بأسهل طريقة'
      },
      {
        title: 'أذكاري',
        description: 'أذكار الصباح والمساء وأذكار أخرى'
      },
      {
        title: 'مواعيد السعودية',
        description: 'الوقت المتبقي للتواريخ المهمة في المملكة'
      },
      {
        title: 'محلل البيانات',
        description: 'حلل البيانات وحول JSON/CSV إلى أكواد مُكتوبة تلقائياً'
      },
      {
        title: 'البريد المؤقت',
        description: 'إنشاء بريد مؤقت لاستقبال الرسائل بدون كشف هويتك'
      },
      {
        title: 'المزيد',
        description: 'استكشف المزيد من الخدمات والأدوات'
      }
    ]
  },
  about: {
    title: 'أسامة الزبيدي',
    subtitle: 'محلل بيانات ، مطور ويب ، متخصص رياضيات',
    description: 'أستطيع تحويل الأرقام إلى ضحك، والكود إلى قهوة!',
    tagline: 'إنشاء حلول ويب قابلة للتطوير وديناميكية ومتجاوبة',
    technicalSkillsTitle: 'المهارات التقنية',
    workExperienceTitle: 'الخبرة العملية',
    projectsTitle: 'مشاريعي',
    contact: 'تواصل معي',
    contactDescription: 'دعنا نبني شيئاً رائعاً معاً',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    message: 'الرسالة',
    send: 'إرسال',
    technicalSkills: {
      html: 'HTML',
      css: 'CSS',
      scss: 'SCSS',
      tailwind: 'Tailwind CSS',
      javascript: 'JavaScript',
      node: 'Node.js',
      angular: 'Angular',
      react: 'React',
      github: 'GitHub',
      gitbash: 'Git Bash',
      php: 'PHP',
      java: 'Java',
      springboot: 'Spring Boot',
      express: 'Express.js',
      mongodb: 'MongoDB',
      postgresql: 'PostgreSQL',
      python: 'Python',
      typescript: 'TypeScript',
      remix: 'Remix',
      mysql: 'MySQL',
      docker: 'Docker',
      aws: 'AWS',
      firebase: 'Firebase'
    },
    workExperience: {
      current: 'وظيفة بدوام كامل',
      internship: 'تدريب',
      freelance: 'عمل حر',
      location: 'الموقع',
      responsibilities: 'المسؤوليات'
    },
    projects: {
      viewLive: 'عرض مباشر',
      viewCode: 'عرض الكود',
      technologies: 'التقنيات المستخدمة'
    }
  },
  tabs: {
    education: 'التعليم',
    experience: 'الخبرات',
    skills: 'المهارات',
    basic: 'المعلومات الأساسية',
    summary: 'الملخص',
    layout: 'التخطيط'
  },
  education: {
    add: 'إضافة مؤهل تعليمي',
    remove: 'حذف المؤهل التعليمي',
    institution: 'المؤسسة التعليمية',
    location: 'الموقع',
    degree: 'الدرجة العلمية',
    field: 'مجال الدراسة',
    date: 'التاريخ',
    gpa: 'المعدل التراكمي',
    achievements: 'الإنجازات الأكاديمية',
    reorder: 'إعادة ترتيب',
    showInResume: 'إظهار في السيرة',
    hideFromResume: 'إخفاء من السيرة',
    qualification: 'مؤهل',
    qualifications: 'مؤهلات'
  },
  experience: {
    add: 'إضافة خبرة',
    remove: 'حذف الخبرة',
    position: 'المنصب',
    company: 'الشركة',
    location: 'الموقع',
    start: 'تاريخ البدء',
    end: 'تاريخ الانتهاء',
    responsibilities: 'المسؤوليات',
    reorder: 'إعادة ترتيب',
    expandAll: 'توسيع الكل',
    collapseAll: 'طي الكل',
    saveState: 'حفظ الحالة',
    restoreState: 'استعادة الحالة',
    copyExperience: 'نسخ الخبرة',
    moveUp: 'نقل لأعلى',
    moveDown: 'نقل لأسفل',
    experience: 'خبرة',
    experiences: 'خبرات'
  },
  skills: {
    addCategory: 'إضافة فئة مهارات',
    removeCategory: 'حذف فئة المهارات',
    addSkill: 'إضافة مهارة',
    removeSkill: 'حذف المهارة',
    categoryName: 'فئة المهارات',
    skill: 'المهارة',
    reorder: 'إعادة ترتيب',
    expandAll: 'توسيع الكل',
    collapseAll: 'طي الكل',
    saveState: 'حفظ الحالة',
    restoreState: 'استعادة الحالة',
    copyCategory: 'نسخ فئة المهارات',
    moveUp: 'نقل لأعلى',
    moveDown: 'نقل لأسفل',
    category: 'فئة',
    categories: 'فئات'
  },
  resume: {
    basicInfo: {
      title: 'المعلومات الأساسية',
      name: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف',
      location: 'الموقع',
      website: 'الموقع الإلكتروني',
      linkedin: 'لينكد إن',
    },
    summary: {
      title: 'الملخص المهني',
      placeholder: 'اكتب ملخصاً موجزاً عن خلفيتك المهنية ونقاط قوتك الرئيسية...',
    },
    experience: {
      title: 'الخبرة العملية',
      add: 'إضافة خبرة',
      position: 'المنصب',
      company: 'الشركة',
      location: 'الموقع',
      startDate: 'تاريخ البدء',
      endDate: 'تاريخ الانتهاء',
      present: 'حالياً',
      responsibilities: 'المسؤوليات',
      addResponsibility: 'إضافة مسؤولية',
    },
    education: {
      title: 'التعليم',
      add: 'إضافة تعليم',
      institution: 'المؤسسة التعليمية',
      degree: 'الدرجة العلمية',
      field: 'مجال الدراسة',
      location: 'الموقع',
      startDate: 'تاريخ البدء',
      endDate: 'تاريخ الانتهاء',
      present: 'حالياً',
      gpa: 'المعدل التراكمي',
      description: 'الوصف',
    },
    skills: {
      title: 'المهارات',
      add: 'إضافة مهارة',
      name: 'اسم المهارة',
      level: 'مستوى الإتقان',
      levels: {
        beginner: 'مبتدئ',
        intermediate: 'متوسط',
        advanced: 'متقدم',
        expert: 'خبير',
      },
    },
  },
  layout: {
    title: 'التنسيق',
    fontSize: 'حجم الخط',
    lineHeight: 'ارتفاع السطر',
    marginV: 'الهامش العمودي',
    marginH: 'الهامش الأفقي',
    color: 'اللون',
    align: 'اتجاه النص',
    rtl: 'العربية',
    ltr: 'الإنجليزية',
    template: 'القالب',
    selectTemplate: 'اختر قالباً',
  },
  templates: {
    professional: {
      name: 'احترافي',
      description: 'تصميم نظيف واحترافي مُحسّن لأنظمة ATS',
    },
    classic: {
      name: 'كلاسيكي عمودين',
      description: 'تصميم تقليدي مع التركيز على الخصائص الشخصية',
    },
    minimal: {
      name: 'مبسط',
      description: 'تصميم مباشر لأقصى توافق مع أنظمة ATS',
    },
    timeline: {
      name: 'الخط الزمني',
      description: 'تصميم زمني يركز على تطور الخبرة',
    },
    modern: {
      name: 'حديث',
      description: 'تصميم معاصر مع توافق قوي مع أنظمة ATS',
    },
  },
  navigation: {
    basicInfo: 'المعلومات الأساسية',
    summary: 'الملخص',
    experience: 'الخبرة',
    education: 'التعليم',
    skills: 'المهارات',
    layout: 'التنسيق',
    preview: 'المعاينة',
  },
  errors: {
    required: 'هذا الحقل مطلوب',
    invalidEmail: 'البريد الإلكتروني غير صالح',
    invalidPhone: 'رقم الهاتف غير صالح',
    invalidDate: 'التاريخ غير صالح',
    invalidGPA: 'يجب أن يكون المعدل التراكمي بين 0 و 4.0',
  },
  messages: {
    saveSuccess: 'تم حفظ السيرة الذاتية بنجاح',
    saveError: 'خطأ في حفظ السيرة الذاتية',
    deleteConfirm: 'هل أنت متأكد من حذف هذا العنصر؟',
    unsavedChanges: 'لديك تغييرات غير محفوظة. هل أنت متأكد من المغادرة؟',
  },
  dataAnalytics: {
    title: 'محلل البيانات الذكي',
    subtitle: 'حلل البيانات وحول JSON/CSV إلى أكواد مُكتوبة تلقائياً',
    description: 'أداة متقدمة لتحليل البيانات وتوليد الأكواد في لغات برمجة متعددة',
    
    // رفع البيانات
    upload: {
      title: 'رفع البيانات',
      subtitle: 'اسحب وأفلت ملف JSON أو CSV، أو انسخ والصق البيانات',
      dragDrop: 'اسحب وأفلت الملف هنا',
      or: 'أو',
      browse: 'تصفح الملفات',
      paste: 'انسخ والصق البيانات',
      supportedFormats: 'الملفات المدعومة: JSON, CSV',
      maxSize: 'الحد الأقصى: 10MB',
      clear: 'مسح البيانات',
      demo: 'استخدام بيانات تجريبية'
    },
    
    // تحليل البيانات
    analysis: {
      title: 'تحليل البيانات',
      subtitle: 'اكتشف بنية البيانات وأنواعها تلقائياً',
      analyzing: 'جاري تحليل البيانات...',
      error: 'خطأ في تحليل البيانات',
      success: 'تم تحليل البيانات بنجاح',
      
      // الإحصائيات
      stats: {
        title: 'الإحصائيات',
        totalRecords: 'إجمالي السجلات',
        totalFields: 'إجمالي الحقول',
        uniqueFields: 'الحقول الفريدة',
        enumFields: 'الحقول المحددة',
        idFields: 'حقول المعرفات',
        requiredFields: 'الحقول المطلوبة',
        nullableFields: 'الحقول القابلة للإلغاء'
      },
      
      // الحقول
      fields: {
        title: 'تحليل الحقول',
        name: 'اسم الحقل',
        type: 'النوع',
        nullable: 'قابل للإلغاء',
        unique: 'فريد',
        required: 'مطلوب',
        examples: 'أمثلة',
        statistics: 'الإحصائيات',
        suggestions: 'الاقتراحات'
      }
    },
    
    // توليد الكود
    output: {
      title: 'توليد الكود',
      subtitle: 'اختر اللغة البرمجية المطلوبة',
      copy: 'نسخ',
      copied: 'تم النسخ',
      download: 'تحميل',
      languages: {
        typescript: 'TypeScript',
        python: 'Python',
        sql: 'SQL',
        go: 'Go',
        java: 'Java',
        csharp: 'C#',
        php: 'PHP',
        rust: 'Rust',
        swift: 'Swift',
        kotlin: 'Kotlin',
        zod: 'Zod',
        pydantic: 'Pydantic',
        django: 'Django',
        fastapi: 'FastAPI',
        sqlalchemy: 'SQLAlchemy',
        mongoose: 'Mongoose',
        prisma: 'Prisma',
        sequelize: 'Sequelize',
        typeorm: 'TypeORM',
        jsonSchema: 'JSON Schema',
        openapi: 'OpenAPI',
        protobuf: 'Protocol Buffers',
        graphql: 'GraphQL'
      }
    },
    
    // التصوير البصري
    visualization: {
      title: 'التصوير البصري للبيانات',
      subtitle: 'اكتشف الأنماط والعلاقات في بياناتك من خلال الرسوم البيانية التفاعلية',
      generating: 'جاري إنشاء الرسوم البيانية...',
      summary: 'ملخص سريع',
      charts: 'الرسوم البيانية',
      insights: 'الرؤى المكتشفة',
      recommendations: 'التوصيات',
      dataPoints: 'نقطة بيانات',
      chart: 'رسم بياني',
      type: 'النوع',
      labels: 'الأعمدة'
    },
    
    // الميزات
    features: {
      title: 'الميزات المتقدمة',
      items: [
        {
          icon: '🔍',
          title: 'تحليل ذكي',
          description: 'كشف تلقائي لأنواع البيانات والعلاقات'
        },
        {
          icon: '📊',
          title: 'إحصائيات متقدمة',
          description: 'تحليل شامل للبيانات مع النسب المئوية'
        },
        {
          icon: '🎯',
          title: 'توليد أكواد',
          description: 'دعم 20+ لغة برمجة وإطار عمل'
        },
        {
          icon: '📈',
          title: 'رسوم بيانية',
          description: 'تصوير بصري تفاعلي للبيانات'
        },
        {
          icon: '🔧',
          title: 'تحسينات تلقائية',
          description: 'اقتراحات لتحسين بنية البيانات'
        },
        {
          icon: '⚡',
          title: 'أداء عالي',
          description: 'معالجة سريعة للبيانات الكبيرة'
        }
      ]
    },
    
    // الأمثلة
    examples: {
      title: 'أمثلة على البيانات',
      items: [
        {
          name: 'بيانات المستخدمين',
          description: 'مثال على بيانات المستخدمين مع معلومات شخصية',
          data: JSON.stringify([
            { id: 1, name: 'أحمد محمد', email: 'ahmed@example.com', age: 25, city: 'الرياض', isActive: true },
            { id: 2, name: 'فاطمة علي', email: 'fatima@example.com', age: 30, city: 'جدة', isActive: false },
            { id: 3, name: 'محمد حسن', email: 'mohammed@example.com', age: 28, city: 'الدمام', isActive: true }
          ], null, 2)
        },
        {
          name: 'بيانات المنتجات',
          description: 'مثال على بيانات المنتجات مع الأسعار والتصنيفات',
          data: JSON.stringify([
            { id: 1, name: 'لابتوب', price: 2500.50, category: 'إلكترونيات', stock: 15, rating: 4.5 },
            { id: 2, name: 'هاتف ذكي', price: 1200.00, category: 'إلكترونيات', stock: 8, rating: 4.2 },
            { id: 3, name: 'كتاب برمجة', price: 45.99, category: 'كتب', stock: 50, rating: 4.8 }
          ], null, 2)
        },
        {
          name: 'بيانات المبيعات',
          description: 'مثال على بيانات المبيعات مع التواريخ والمبالغ',
          data: JSON.stringify([
            { id: 1, date: '2024-01-15', amount: 1500.00, customer: 'شركة التقنية', product: 'برمجيات' },
            { id: 2, date: '2024-01-16', amount: 2300.50, customer: 'مكتب المحاماة', product: 'استشارات' },
            { id: 3, date: '2024-01-17', amount: 800.25, customer: 'المطعم الشعبي', product: 'طعام' }
          ], null, 2)
        },
        {
          name: 'بيانات CSV',
          description: 'مثال على بيانات CSV للموظفين',
          data: `name,age,department,salary,join_date
أحمد محمد,25,تطوير,5000,2023-01-15
فاطمة علي,30,تسويق,4500,2022-06-20
محمد حسن,28,مبيعات,4800,2023-03-10
سارة أحمد,32,موارد بشرية,4200,2021-12-05`
        }
      ]
    },
    
    // الإجراءات
    actions: {
      copy: 'نسخ',
      copied: 'تم النسخ',
      download: 'تحميل',
      clear: 'مسح',
      analyze: 'تحليل',
      generate: 'توليد',
      visualize: 'تصوير',
      export: 'تصدير',
      import: 'استيراد',
      save: 'حفظ',
      load: 'تحميل',
      reset: 'إعادة تعيين',
      help: 'مساعدة',
      settings: 'الإعدادات'
    },
    
    // لوحة التحكم المتطورة
    dashboard: {
      title: 'لوحة التحكم المتطورة',
      subtitle: 'تصوير بصري متقدم للبيانات مع تحليلات تفاعلية',
      show: 'عرض لوحة التحكم المتطورة',
      hide: 'إخفاء لوحة التحكم',
      metrics: 'المقاييس',
      charts: 'الرسوم البيانية',
      filters: 'الفلاتر',
      export: 'تصدير',
      share: 'مشاركة',
      refresh: 'تحديث',
      autoRefresh: 'تحديث تلقائي',
      viewMode: 'وضع العرض',
      grid: 'شبكة',
      list: 'قائمة',
      expand: 'تكبير',
      compress: 'تصغير',
      hideChart: 'إخفاء الرسم البياني',
      showChart: 'إظهار الرسم البياني',
      loading: 'جاري التحميل...',
      noData: 'لا توجد بيانات متاحة',
      noCharts: 'لا توجد رسوم بيانية متاحة',
      totalRecords: 'إجمالي السجلات',
      totalColumns: 'إجمالي الأعمدة',
      numericColumns: 'المتغيرات الرقمية',
      categoricalColumns: 'المتغيرات الفئوية',
      dateColumns: 'المتغيرات الزمنية',
      dataCompleteness: 'اكتمال البيانات',
      missingData: 'البيانات المفقودة',
      uniqueValues: 'القيم الفريدة',
      correlations: 'الارتباطات',
      trends: 'الاتجاهات',
      insights: 'الرؤى',
      recommendations: 'التوصيات',
      availableFilters: 'الفلاتر المتاحة',
      selectFilter: 'اختر الفلتر',
      applyFilters: 'تطبيق الفلاتر',
      clearFilters: 'مسح الفلاتر',
      filterBy: 'فلترة حسب',
      dateRange: 'نطاق التاريخ',
      selectDate: 'اختر التاريخ',
      selectValues: 'اختر القيم',
      enterValue: 'أدخل القيمة',
      selectAll: 'اختيار الكل',
      deselectAll: 'إلغاء اختيار الكل',
      chartControls: 'أدوات التحكم في الرسم البياني',
      exportChart: 'تصدير الرسم البياني',
      shareChart: 'مشاركة الرسم البياني',
      fullscreen: 'ملء الشاشة',
      exitFullscreen: 'خروج من ملء الشاشة',
      dashboardConfig: 'إعدادات لوحة التحكم',
      saveConfig: 'حفظ الإعدادات',
      loadConfig: 'تحميل الإعدادات',
      resetConfig: 'إعادة تعيين الإعدادات',
      customizeTheme: 'تخصيص السمة',
      lightTheme: 'السمة الفاتحة',
      darkTheme: 'السمة المظلمة',
      autoTheme: 'السمة التلقائية',
      purpleTheme: 'السمة البنفسجية',
      blueTheme: 'السمة الزرقاء',
      greenTheme: 'السمة الخضراء'
    }
  },
  
  // البريد المؤقت
  tempMail: {
    title: 'البريد المؤقت',
    subtitle: 'إنشاء بريد مؤقت لاستقبال الرسائل بدون كشف هويتك',
    description: 'خدمة بريد مؤقت آمنة ومجانية لاستقبال الرسائل المؤقتة',
    
    // الواجهة الرئيسية
    interface: {
      generateNew: 'إنشاء بريد جديد',
      deleteEmail: 'حذف البريد',
      copyEmail: 'نسخ البريد',
      copied: 'تم النسخ',
      refresh: 'تحديث',
      loading: 'جاري التحميل...',
      noEmails: 'لا توجد رسائل',
      error: 'حدث خطأ',
      retry: 'إعادة المحاولة'
    },
    
    // صندوق الوارد
    inbox: {
      title: 'صندوق الوارد',
      empty: 'صندوق الوارد فارغ',
      loading: 'جاري تحميل الرسائل...',
      error: 'خطأ في تحميل الرسائل',
      noMessages: 'لا توجد رسائل في صندوق الوارد',
      refresh: 'تحديث الرسائل',
      markAsRead: 'تحديد كمقروء',
      markAsUnread: 'تحديد كغير مقروء',
      delete: 'حذف الرسالة',
      reply: 'رد',
      forward: 'إعادة توجيه',
      from: 'من',
      to: 'إلى',
      subject: 'الموضوع',
      date: 'التاريخ',
      time: 'الوقت',
      attachments: 'المرفقات',
      noAttachments: 'لا توجد مرفقات'
    },
    
    // تفاصيل الرسالة
    message: {
      title: 'تفاصيل الرسالة',
      back: 'العودة للرسائل',
      sender: 'المرسل',
      recipient: 'المستقبل',
      subject: 'الموضوع',
      date: 'التاريخ والوقت',
      content: 'المحتوى',
      htmlContent: 'المحتوى HTML',
      textContent: 'المحتوى النصي',
      attachments: 'المرفقات',
      download: 'تحميل',
      view: 'عرض',
      noContent: 'لا يوجد محتوى',
      loading: 'جاري تحميل الرسالة...',
      error: 'خطأ في تحميل الرسالة'
    },
    
    // إعدادات البريد
    settings: {
      title: 'إعدادات البريد المؤقت',
      autoRefresh: 'تحديث تلقائي',
      refreshInterval: 'فترة التحديث',
      seconds: 'ثواني',
      minutes: 'دقائق',
      enableNotifications: 'تفعيل الإشعارات',
      soundAlerts: 'تنبيهات صوتية',
      desktopNotifications: 'إشعارات سطح المكتب',
      saveSettings: 'حفظ الإعدادات',
      resetSettings: 'إعادة تعيين الإعدادات'
    },
    
    // الميزات
    features: {
      title: 'ميزات البريد المؤقت',
      items: [
        {
          icon: '🔒',
          title: 'خصوصية كاملة',
          description: 'لا تحتاج لتسجيل حساب أو كشف هويتك'
        },
        {
          icon: '⚡',
          title: 'إنشاء فوري',
          description: 'إنشاء بريد مؤقت في ثواني معدودة'
        },
        {
          icon: '📧',
          title: 'استقبال فوري',
          description: 'استقبال الرسائل فور وصولها'
        },
        {
          icon: '🗑️',
          title: 'حذف آمن',
          description: 'حذف البريد والرسائل بأمان تام'
        },
        {
          icon: '📱',
          title: 'متوافق مع الجوال',
          description: 'يعمل على جميع الأجهزة والمتصفحات'
        },
        {
          icon: '🆓',
          title: 'مجاني بالكامل',
          description: 'لا توجد رسوم أو اشتراكات'
        }
      ]
    },
    
    // الاستخدامات
    useCases: {
      title: 'استخدامات البريد المؤقت',
      items: [
        {
          title: 'التسجيل في المواقع',
          description: 'تسجيل في المواقع التي تتطلب بريد إلكتروني'
        },
        {
          title: 'اختبار الخدمات',
          description: 'اختبار خدمات البريد الإلكتروني'
        },
        {
          title: 'حماية الخصوصية',
          description: 'حماية بريدك الشخصي من الرسائل المزعجة'
        },
        {
          title: 'التسويق المؤقت',
          description: 'استقبال عروض التسويق المؤقتة'
        },
        {
          title: 'التواصل المؤقت',
          description: 'التواصل مع أشخاص لا تعرفهم'
        },
        {
          title: 'التحقق من الخدمات',
          description: 'التحقق من صحة خدمات البريد الإلكتروني'
        }
      ]
    },
    
    // النصائح
    tips: {
      title: 'نصائح للاستخدام الآمن',
      items: [
        'لا تستخدم البريد المؤقت للمعاملات المالية المهمة',
        'احذف البريد المؤقت بعد الانتهاء من استخدامه',
        'لا ترسل معلومات حساسة عبر البريد المؤقت',
        'استخدم بريد مؤقت مختلف لكل موقع',
        'تأكد من حذف البريد قبل إغلاق المتصفح'
      ]
    },
    
    // الرسائل
    messages: {
      emailGenerated: 'تم إنشاء البريد المؤقت بنجاح',
      emailDeleted: 'تم حذف البريد المؤقت بنجاح',
      emailCopied: 'تم نسخ البريد المؤقت',
      refreshSuccess: 'تم تحديث الرسائل بنجاح',
      refreshError: 'خطأ في تحديث الرسائل',
      deleteConfirm: 'هل أنت متأكد من حذف هذا البريد؟',
      deleteMessageConfirm: 'هل أنت متأكد من حذف هذه الرسالة؟',
      settingsSaved: 'تم حفظ الإعدادات بنجاح',
      settingsReset: 'تم إعادة تعيين الإعدادات'
    }
  }
}; 